// extracted by mini-css-extract-plugin
module.exports = {"main":"index_main__2eagc","item":"index_item__1Sr93","title":"index_title__uwxxC","time":"index_time__3pz1w"};